import React from 'react';
import {Link} from 'react-router-dom';
import {Button} from '../';

const ServiceBoxOneEInvoice = ({bgImage, icon, title, text, path, className})=> (
  <div style={{padding:'10px 20px',minHeight:150}} className={`service-style1 ${className || ''}`}>
    <div className="service-bg background-image" style={{backgroundImage: 'url(' + 'images/bg/sr-box-bg-1.jpg' + ')'}}></div>
    <h3 className="service-title h5"><Link to={"#"}>{title}</Link></h3>
    <p className="service-text">{text}</p>
  </div>
);

export default ServiceBoxOneEInvoice;